import { type NestableContent } from "@prismicio/types-internal/lib/content"
import type { Link } from "@prismicio/types-internal/lib/customtypes"

import { getLinkContent, getRepeatableContent } from "../../core/repeatable"
import { LinkField } from "./LinkField"
import { RepeatableLinkField } from "./RepeatableLinkField"

interface LinkOrRepeatableLinkFieldProps {
  content: NestableContent | undefined
  id: string
  field: Link
  onContentChange: (content: NestableContent | undefined) => void
  readOnly: boolean
}

export function LinkOrRepeatableLinkField(
  props: LinkOrRepeatableLinkFieldProps,
) {
  const { content, id, field, onContentChange, readOnly } = props
  const fieldProps = { id, readOnly, onContentChange }

  if (field.config?.repeat) {
    return (
      <RepeatableLinkField
        {...fieldProps}
        field={field}
        content={getRepeatableContent(content)}
      />
    )
  }

  return (
    <LinkField
      {...fieldProps}
      field={field}
      content={getLinkContent(content)}
    />
  )
}
